import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-feature-style1',
  templateUrl: './feature-style1.component.html',
  styleUrls: ['./feature-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FeatureStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/feature-style1/feature-style1.component.ts